import { Icon } from '@aqarmap/aqarmap-ui';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ListingNote = ({
  noteText,
  handleOpenNoteModal,
  isSheared,
}: {
  noteText: string;
  handleOpenNoteModal: () => void;
  isSheared?: boolean;
}) => {
  const { t } = useTranslation('app');
  const [note, setNote] = useState(noteText);

  const hideNote = !note && isSheared;

  useEffect(() => {
    setNote(noteText);
  }, [noteText]);

  return hideNote ? null : (
    <button
      type="button"
      className={[
        'flex w-full items-center justify-between gap-1.5x rounded-[12px] p-1.5x text-start transition-colors px-2x md:px-3x',
        note
          ? 'bg-orange_light_2 text-orange_dark_2'
          : 'bg-gray_light_1 text-blue',
      ].join(' ')}
      onClick={() => handleOpenNoteModal()}
      disabled={isSheared}
    >
      <div className="flex-1 flex min-w-0 items-center gap-1.5x overflow-hidden">
        <Icon name="note" className={note ? 'text-orange' : ''} />
        <span className="text-body-2 flex-1 flex flex-wrap">
          {note || t('savedPropertiesAddNote')}
          {note && (
            <span className="text-blue text-link-1 ps-1 md:hidden inline-block">
              {t('edit')}
            </span>
          )}
        </span>
      </div>
      {note && !isSheared && (
        <Icon name="edit" className="text-blue hidden md:block" />
      )}
    </button>
  );
};

export default ListingNote;
